import { Feature } from '../../components/feature';
import Button from '../../components/Button';
import { Brush, Image, ScanQrCode } from 'lucide-react';
import { MediaCard } from '../../AvatarWhatsapp/Whatsapp';

const points = [
    { icon: <Image className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Photo fix and enhance", description: "AI makes low-quality photos look clear and bright automatically." },
    { icon: <Brush className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Clean background", description: "AI removes clutter and makes background school-approved." },
    { icon: <ScanQrCode className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Dual-use QR code", description: "Scan to mark attendance or to pay fees — same code does both." },
]


export default function IdCard() {
    return  <Feature
                badge={"ADD ONS"}
                title={"AI-Powered ID Cards — Smart, beautiful, and powerful"}
                description={
                    <div className='space-y-8'>
                        <p>
                            Tired of blurry photos, bad backgrounds, and messy ID cards? Our AI fixes photos and designs ID cards for you. Every card gets a unique QR code for attendance and payments.
                        </p>
                        <div className="space-y-4 md:text-left">
                            {points?.map((item, index) => <MediaCard key={"IdCard" + index} {...item} />)}
                        </div>
                    </div>
                }
                imageAlt="startup"
                imageQuery="images/new-landing-page/idcardv2.png"
                cta={
                    <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
                        <Button label='Activate AI ID Cards' type='gradient' />
                        <Button label="Join Live Webinar" type='outlined' />
                    </div>
                }
            />
}